import React from 'react';
import Experience from '../../components/experience';
import { getProp, getPropMarked } from '../utils';

const ExperiencePreview = (props) => {
  const title = getProp(props, 'title');
  const subtitle = getPropMarked(props, 'subtitle');
  const time = getProp(props, 'time');
  const info = getPropMarked(props, 'info');
  const activities = getProp(props, 'activities');
  const description = getPropMarked(props, 'description');

  return (
    <Experience
      {...{
        title,
        subtitle,
        time,
        info,
        activities,
        description,
        startOpen: true
      }}
    />
  );
};

export default ExperiencePreview;
